import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularPerson: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_person"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="person icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 28 28"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M21 17C22.6569 17 24 18.3431 24 20V20.7146C24 24.2924 19.7895 27 14 27C8.21053 27 4 24.4333 4 20.7146V20C4 18.3431 5.34315 17 7 17H21ZM21 18.5H7C6.2203 18.5 5.57955 19.0949 5.50687 19.8555L5.5 20V20.7146C5.5 23.389 8.88879 25.5 14 25.5C18.926 25.5 22.3548 23.3951 22.4955 20.876L22.5 20.7146V20C22.5 19.2203 21.9051 18.5796 21.1445 18.5069L21 18.5ZM14 3C17.3137 3 20 5.68629 20 9C20 12.3137 17.3137 15 14 15C10.6863 15 8 12.3137 8 9C8 5.68629 10.6863 3 14 3ZM14 4.5C11.5147 4.5 9.5 6.51472 9.5 9C9.5 11.4853 11.5147 13.5 14 13.5C16.4853 13.5 18.5 11.4853 18.5 9C18.5 6.51472 16.4853 4.5 14 4.5Z" />
      </svg>
    </span>
  );
};

export { RegularPerson };
